import {
  Avatar,
  Badge,
  Icon,
  IconButton,
  Popover,
  Tooltip,
} from "@material-ui/core";
import { useState } from "react";
import UserInfo from "./userInfo";
import { getUserName, Translator } from "@itarget/shared";
import { useDispatch } from 'react-redux'
import { auth } from '../../../../redux'

function getInitials(name) {
  if (!name) return "";
  const parts = name.split(" ").filter((word) => word);
  return parts.length === 0
    ? ""
    : parts.length === 1
    ? parts[0][0]
    : parts[0][0] + parts[1][0];
}

export default function Profile({
  classes,
  user,
  shoppingCarts,
  statusAssociated,
}) {
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip title="Carrinho de compras">
        <IconButton
          className={classes.authenticateButtons}
          href="/shopping-cart"
        >
          <Badge
            color="error"
            className={classes.shoppingBadge}
            badgeContent={
              shoppingCarts.length > 9 ? "+9" : shoppingCarts.length
            }
          >
            <Icon className={classes.profileIcon}>shopping_cart</Icon>
          </Badge>
        </IconButton>
      </Tooltip>

      <div onClick={handleOpen} className={classes.authenticateContext}>
        <Avatar alt={user?.data?.nome} src={user?.data?.foto}>
          {getInitials(user?.data?.nome)}
        </Avatar>

        <UserInfo
          classes={classes}
          name={getUserName(user?.data?.nome)}
          status={statusAssociated?.data?.status}
          financialStatus={statusAssociated?.data?.financialStatus}
        />
      </div>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        className={classes.popoverContainer}
      >
        <div className={classes.popoverContent}>
          <a
            href="/new-panel"
            className={classes.popoverLink}
            onClick={handleClose}
          >
            <Translator transRef="translation.Meus dados" />
          </a>
          <a
            href="#"
            className={classes.popoverLink}
            onClick={() => {
              handleClose();
              dispatch(auth.actions.logout())
            }}
          >
            <Translator transRef="translation.Sair" />
          </a>
        </div>
      </Popover>
    </>
  );
}
